import { render, staticRenderFns } from "./ListJob.vue?vue&type=template&id=2edbe4f4&"
import script from "./ListJob.vue?vue&type=script&lang=js&"
export * from "./ListJob.vue?vue&type=script&lang=js&"
import style0 from "./ListJob.vue?vue&type=style&index=0&id=2edbe4f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports